// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2r7IX","questions":"styles_questions__9GId0","footer":"styles_footer__3sfAI"};